// Libraries
import React from 'react';
import { useTranslation } from 'react-i18next';

// Enums
import { EngagementReportQuestionType } from 'engagementReport/enums/propTypes';

const BasicReport = ({ question }) => {
  const { t } = useTranslation();
  const analysis = question.analysis.sort((a, b) => b.count - a.count).slice(0, 10);

  const renderSubtitle = () => {
    if (question.data.length === 0) return t('engagement_report.no_responses');
    if (analysis.length === 0) return t('engagement_report.no_keywords');
    return t('engagement_report.top_keywords');
  };

  return (
    <div className="basic-report">
      <div className="basic-report__subtitle">{renderSubtitle()}</div>
      {analysis.map((entry, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="basic-report__keyword" key={index}>
          <div className="basic-report__keyword-position">{`${index + 1}.`}</div>
          <div className="basic-report__keyword-value">{entry.word}</div>
        </div>
      ))}
    </div>
  );
};

BasicReport.propTypes = {
  question: EngagementReportQuestionType.isRequired,
};

export default BasicReport;
